import React, { useEffect, useState } from "react";
import PersonIcon from "@mui/icons-material/Person";
import NotificationsIcon from "@mui/icons-material/Notifications";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import { useDispatch, useSelector } from "react-redux";
import { toggleTheme } from "../../Redux/Slices/themeSlice";
import { useNavigate } from "react-router-dom";
import ProfileMenu from "./profileMenu";
import axiosInstance from "../../configuration/request";
import { useSnackbar } from "../../component/SnackbarContext";
import { endpoints } from "../../constants/notification";
import { setNotificationCount } from "../../Redux/Slices/counterSlice";

function HeaderRightSection() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {isNotificationUnreadCount}  = useSelector((state) => state.counter);
  const [notificationsCount, setNotificationsCount] = useState([]);
  const theme = useSelector((state) => state.theme.mode);
  const { loginDetails } = useSelector((state) => state.counter);
  const showSnackbar = useSnackbar();


    useEffect(() => {
       if (!loginDetails?.userType) return;
    fetchNotification();
  }, [loginDetails?.userType,isNotificationUnreadCount]);

  const fetchNotification = () => {
        const url = endpoints[loginDetails?.userType] || endpoints[""];
    axiosInstance
      .get(url)
      .then(
        res =>{
           setNotificationsCount(res?.data?.unreadCount || 0)
           dispatch(setNotificationCount(res?.data?.unreadCount || 0));
          }
      )
      .catch(err =>
        showSnackbar(err?.response?.data?.message || "Something went wrong!", "error")
      );
  };


  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
    const handleNotification = () => {
      if(loginDetails.userType === "business user" || loginDetails.userType === "employee user"){
         navigate("/app/business/notification")
      }else if(loginDetails.userType === "normal user"){
         navigate("/notification")
      }else if(loginDetails.userType === "admin"){
         navigate("/app/notification")
      }else if(loginDetails.userType === "delivery user"){
         navigate("/delivery/notification")
      }
    
  };

  useEffect(() => {
    const root = window.document.documentElement;
    theme === "dark" ? root.classList.add("dark") : root.classList.remove("dark");
  }, [theme]);

  return (
    <div className="flex items-center gap-4">
      {/* <div
        className="flex items-center justify-center rounded-full border border-[#C4C4C4] w-10 h-10 ml-2 cursor-pointer"
        onClick={() => dispatch(toggleTheme())}
        title={`Switch to ${theme === "dark" ? "Light" : "Dark"} Mode`}
      >
        {theme === "dark" ? (
          <LightModeIcon className="text-yellow-400" fontSize="medium" />
        ) : (
          <DarkModeIcon className="text-gray-800" fontSize="medium" />
        )}
      </div> */}

      {/* <div
        onClick={() => handleNotification()}
        className="flex items-center justify-center rounded-full border border-[#C4C4C4] w-10 h-10 ml-2 cursor-pointer"
      >
        <NotificationsIcon fontSize="medium" className="text-[#3587B8]" />
      </div> */}

       <div
        onClick={handleNotification}
        className="relative flex items-center justify-center rounded-full border border-[#C4C4C4] w-10 h-10 ml-2 cursor-pointer"
      >
        <NotificationsIcon fontSize="medium" className="text-[#3587B8]" />
        {notificationsCount > 0 && (
          <span className="absolute -top-1 -right-2 inline-flex items-center justify-center px-1 py-0.5 rounded-full text-[10px] font-bold bg-red-500 text-white min-w-[20px] min-h-[18px]">
            {notificationsCount > 99 ? "99+" :  notificationsCount}
          </span>
        )}
      </div>

      <div
        onClick={handleMenuOpen}
        className="flex items-center justify-center rounded-full border border-[#C4C4C4] w-10 h-10  cursor-pointer"
      >
        <PersonIcon className="text-[#3587B8]" fontSize="medium" />
      </div>

      {/* Profile Popover */}
      <ProfileMenu anchorEl={anchorEl} open={open} handleClose={handleMenuClose} />
    </div>
  );
}

export default HeaderRightSection;
